export default "__VITE_ASSET__DfMa$$XT__"